 export const firebaseConfig = {
    apiKey: "AIzaSyBL4x1NEinp0yDMCGazdm4DzALTj1L9fiI",
    authDomain: "calculator-80332.firebaseapp.com",
    databaseURL: "https://calculator-80332.firebaseio.com",
    projectId: "calculator-80332",
    storageBucket: "calculator-80332.appspot.com",
    messagingSenderId: "508122902060",
    appId: "1:508122902060:web:67e3623bae91af86aaeb89"
  };